export const getImageRoute = (url: string) => {
    if(!url) {
        return "null"
    }

    return `${process.env.REACT_APP_BASE_IMAGE_API_URL}/${url}`
}